import { render, staticRenderFns } from "./fugaiswiper.vue?vue&type=template&id=d0cc5612&scoped=true&"
import script from "./fugaiswiper.vue?vue&type=script&lang=js&"
export * from "./fugaiswiper.vue?vue&type=script&lang=js&"
import style0 from "./fugaiswiper.vue?vue&type=style&index=0&id=d0cc5612&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0cc5612",
  null
  
)

export default component.exports